﻿export const loginModel  = {
    phoneNumber: '',
    password: ''
}
